import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

@Pipe({
  name: 'platformLabel',
  pure: false,
  standalone: false
})
export class PlatformLabelPipe implements PipeTransform {
  constructor(private appConfig: AppConfigService) {}

  transform(value: string | null): string {
    return this.appConfig.getPlatformLanguage(value);
  }
}
